<template>
  <div class="ohm-modal-container">
    <div class="backdrop" @click="callClose"></div>
    <div class="ohm-modal-content">
      <div class="ohm-modal">
        <div class="ohm-modal-inner">
          <div class="ohm-modal-header">
            <slot name="header"></slot>
          </div>
          <div v-if="tabs" class="ohm-modal-tab-container">
            <ul class="ohm-modal-tab-header">
              <li v-for="(tab, name) in tabs" :key="`tab-${name}`" :class="{ active: currentTab === name }">
                <button type="button" class="button button-transparent" @click="currentTab = name">{{ tab }}</button>
              </li>
            </ul>
            <div v-for="(tab, name) in tabs" :key="`tab-content-${name}`" v-show="currentTab === name"
                 class="ohm-modal-tab-content">
              <slot :name="name"></slot>
            </div>
          </div>
          <div v-else class="ohm-modal-body" :class="{ padded: paddedBody }">
            <slot></slot>
          </div>
          <div class="ohm-modal-footer">
            <button v-if="closable" type="button" class="button" @click="callClose">{{ closeLabel }}</button>
            <button v-if="ok" type="button" class="button" @click="callOk">{{ okLabel }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  data: () => ({
    currentTab: null
  }),
  props: {
    closeLabel: {
      type: String,
      default: 'Close'
    },
    ok: { // Include "OK" button
      type: Boolean,
      default: false
    },
    okLabel: {
      type: String,
      default: 'OK'
    },
    tabs: {
      type: Object,
      default: null
    },
    closable: {
      type: Boolean,
      default: true
    },
    paddedBody: {
      type: Boolean,
      default: true
    },
  },
  created() {
    if (this.tabs) {
      this.currentTab = Object.keys(this.tabs)[0]
    }
  },
  methods: {
    callClose() {
      if (this.closable) {
        this.$emit('close')
      }
    },
    callOk() {
      if (this.closable) {
        this.$emit('close')
      }
      this.$emit('ok')
    }
  }
}
</script>

<style lang="sass" scoped>
@use '../styles/variables' as v

.ohm-modal-container
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  z-index: 5000

  .backdrop
    background: rgba(0, 0, 0, 0.5)
    width: 100%
    height: 100%
    position: fixed

  .ohm-modal-content
    overflow-x: hidden
    overflow-y: auto
    width: 100%
    height: 100%
    position: relative
    pointer-events: none

    .ohm-modal
      pointer-events: all
      margin: 50px auto 20px
      //background: v.$light-black
      background: v.$ui-background
      width: 900px
      max-width: 99%
      position: relative
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
      display: grid
      grid-template-rows: auto 1fr auto

      .ohm-modal-inner
        color: v.$white

        &.centered
          position: absolute
          left: 50%
          top: 50%
          transform: translate(-50%, -50%)
          margin: 0

        .ohm-modal-header, .ohm-modal-footer
          padding: 20px 30px

        .ohm-modal-body.padded, .ohm-modal-tab-content
          padding: 20px 40px

        .ohm-modal-header
          //border-bottom: 1px solid v.$light-black2
          font-size: v.$font-size-big
          line-height: 1.5em

        .ohm-modal-tab-container
          .ohm-modal-tab-header
            width: 100%
            display: flex
            border-bottom: 1px solid v.$light-black2
            padding: 0 20px

            li
              button
                position: relative

                &:focus
                  outline: none

                &:after
                  position: absolute
                  left: 0
                  width: 100%
                  content: ''
                  bottom: -1px
                  border-bottom: 1px solid transparent

              &.active button, button:hover
                color: v.$white

              &.active button:after
                border-color: v.$sharp-blue

        .ohm-modal-footer
          display: flex
          flex-wrap: wrap
          justify-content: flex-end

          button
            margin-left: 10px

</style>
